export const environment = {
  production: false,
  defaultLanguage: "en",
  wwwBaseUrl: "",
  api: {
    baseUrl: "https://poff-dev-api.aks-dev-k8s-partner-office-001.claas.com",
    services: {
      commons: {
        coremediaV1: "/commons/coremedia/v1",
        applicationsV1: "/commons/applications/v1",
      },
      infrastructure: {
        usersV1: "/infrastructure/users/v1",
        workshopsV1: "/infrastructure/workshops/v1",
      },
    },
  },
  // TODO: fill in the CoreMedia root.name of the not-found channel's own site (used for
  // X-Site-Hash) — it lives in a different site than the navigation channels below.
  notFound: {
    channelId: "24810",
    siteName: "404 page",
  },
  // Entry point for the footer legal-links menu (Datenschutz/Nutzungsbedingungen/Impressum),
  // loaded via retrieveMenuTree/localized (siteName used for X-Site-Hash).
  footerLegalLinks: {
    channelId: "29536",
    siteName: "legal-start-de",
  },
  // TODO: siteName must match the CoreMedia root.name for the channel (used for X-Site-Hash)
  navigation: {
    defaultIconId: "648466",
    channels: {
      at: {
        de: { channelId: "29156", siteName: "poff-cvg-start-de" },
        en: { channelId: "81936", siteName: "poff-cgs-start-de" },
      },
      de: {
        de: { channelId: "29156", siteName: "poff-cvg-start-de" },
        en: { channelId: "80504", siteName: "connect-shop-de" },
      },
      fr: {
        fr: { channelId: "80504", siteName: "connect-shop-home" },
        en: { channelId: "80554", siteName: "connect-shop-de" },
      },
    },
    additionalTrees: [
      {
        channelId: "82636",
        siteName: "master-en-start",
        routePrefix: "/int",
      },
      {
        channelId: "82810",
        siteName: "poff-master-de",
        routePrefix: "/int",
      },
    ],
    globalTrees: [
      {
        channelId: "29536",
        siteName: "legal-start-de",
        routePrefix: "/legal",
      },
    ],
  },
  caasPreviewHost:
    "https://headless-server-preview.aks-dev-k8s-claas-com-001.claas.com",
  okta: {
    authBaseUrl: "https://sso.claas.com",
    clientId: "0oaae71e67dOKSR6r417",
    issuer: "https://sso.claas.com/oauth2/sso",
  },
  // PIA integration
  pia: {
    countryDefault: "int",
    languageDefault: "en",
    apiOrigin: "https://pia-backend.dehwl-k8-cl-p01.claas.com/api",
    apiToken:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJmM2U3ZTllNzM3YWQ0ZDUzYTk5NTE5NjhkMWM5MTQ4YiIsImV4dF9hdHRyIjp7ImVuaGFuY2VyIjoiWFNVQUEiLCJzdWJhY2NvdW50aWQiOiI2ZWJmMjNjMy1mODk4LTQxNTQtYmQ1Zi1mZWVhNDQ5NmM1OGYiLCJ6ZG4iOiJtb2JpbGVpbm5vdmF0aW9uIn0sInhzLnN5c3RlbS5hdHRyaWJ1dGVzIjp7InhzLnNhbWwuZ3JvdXBzIjpbIkFQUC1DTS1DUE5ERS1BRE1JTiIsIkFQUC1DTS1DUE5VUy1VUy1UUkFDVE9SIl0sInhzLnJvbGVjb2xsZWN0aW9ucyI6WyJBcHBfRFNNX0NDRSIsIkFwcF9NeUNMQUFTX0RFIiwiQnVzaW5lc3NfQXBwbGljYXRpb25fU3R1ZGlvX0RldmVsb3BlciIsIlBvcnRhbF9BZG1pbiIsIkJ1c2luZXNzX0FwcGxpY2F0aW9uX1N0dWRpb19BZG1pbmlzdHJhdG9yIiwiQVBQX01QTl9CQVNFIiwiQXBwX1BJQV9DVkciLCJBcHBfUElBX0lOVCIsIkFwcF9QSUFfQ09BIiwiQXBwX1BJQV9DRiIsIkFwcF9QSUFfSU1QIl19LCJnaXZlbl9uYW1lIjoiSGVubmluZyIsInhzLnVzZXIuYXR0cmlidXRlcyI6e30sImZhbWlseV9uYW1lIjoiUG9obGhhdXNlbiIsInN1YiI6IjM5YTU1NGE2LThmMDEtNGMwYy05OGE4LWZhYzNiOWQwMjNmYSIsInNjb3BlIjpbIm9wZW5pZCIsInVzZXJfYXR0cmlidXRlcyIsInVhYS51c2VyIl0sImNsaWVudF9pZCI6InNiLWNvbS1jbGFhcy1waWEtZGV2LWRldiF0Mjc1NyIsImNpZCI6InNiLWNvbS1jbGFhcy1waWEtZGV2LWRldiF0Mjc1NyIsImF6cCI6InNiLWNvbS1jbGFhcy1waWEtZGV2LWRldiF0Mjc1NyIsImdyYW50X3R5cGUiOiJhdXRob3JpemF0aW9uX2NvZGUiLCJ1c2VyX2lkIjoiMzlhNTU0YTYtOGYwMS00YzBjLTk4YTgtZmFjM2I5ZDAyM2ZhIiwib3JpZ2luIjoiYWdxanRmaHBiLmFjY291bnRzLm9uZGVtYW5kLmNvbSIsInVzZXJfbmFtZSI6IkkwMDA2NzgiLCJlbWFpbCI6Imhlbm5pbmcucG9obGhhdXNlbkBjbGFhcy5jb20iLCJhdXRoX3RpbWUiOjE2MTkxODU5NzMsInJldl9zaWciOiI3NjBlOTYwZiIsImlhdCI6MTYxOTE4NTk3MywiZXhwIjoxNjE5MjI5MTczLCJpc3MiOiJodHRwczovL21vYmlsZWlubm92YXRpb24uYXV0aGVudGljYXRpb24uZXUyMC5oYW5hLm9uZGVtYW5kLmNvbS9vYXV0aC90b2tlbiIsInppZCI6IjZlYmYyM2MzLWY4OTgtNDE1NC1iZDVmLWZlZWE0NDk2YzU4ZiIsImF1ZCI6WyJzYi1jb20tY2xhYXMtcGlhLWRldi1kZXYhdDI3NTciLCJ1YWEiLCJvcGVuaWQiXX0.14KaOfEFmB8yRIAEn2dZEpiR7MtvTJfBvH1_lJlYGKc",
    apiProd: false,
    productDocumentTypes: ["pdf", "mp4"],
    productImagesTypes: ["jpg", "jpeg", "png", "tif", "arw"],
  },
};
